
const reviews = [
  {
    name: "Maheswari.",
    quote:
      "Super best hair style chala bagundhi super super super super super super super super!",
    avatar: "/images/client-pic.jpg",
    icon: "/images/google.png",
    source: "Google",
  },
  {
    name: "C Swetha.",
    quote:
      "They nailed ‘soft glam’—felt like me, just glowier. Photos turned out stunning.",
    avatar: "/images/client-pic.jpg",
    icon: "/images/google.png",
    source: "Google",
  },
  {
    name: "Yuva Sri.",
    quote:
      "I had experience on sunscreen product of Foxtale, it's good working.",
    avatar: "/images/client-pic.jpg",
    icon: "/images/google.png",
    source: "Google",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="section w-full max-w-full overflow-hidden py-16 sm:py-20 md:py-28 relative"
    >
      {/* Background Glow */}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 sm:w-80 sm:h-80 rounded-full bg-sunrise-500/10 blur-3xl" />

        <div className="absolute bottom-0 right-0 w-72 h-72 sm:w-96 sm:h-96 rounded-full bg-blush-500/10 blur-3xl" />
      </div>

      {/* Heading */}
      <div className="w-full max-w-2xl mx-auto text-center px-4">
        <span className="text-xs sm:text-sm uppercase tracking-[0.2em] sm:tracking-[0.25em] text-sunrise-300">
          Client Reviews
        </span>

        <h2 className="mt-3 font-display text-3xl sm:text-4xl md:text-5xl leading-tight">
          Client{" "}
          <span className="text-sunrise-300">
            Love
          </span>
        </h2>

        <p className="mt-3 sm:mt-4 text-sm sm:text-base text-white/70">
          Real words from our beautiful Sunrise family.
        </p>

        {/* Google Rating */}
        <div className="mt-5 sm:mt-6 flex flex-col items-center">
          <div className="flex items-center gap-1 text-sunrise-300 text-lg sm:text-xl">
            ★ ★ ★ ★ ★
          </div>

          <p className="mt-2 text-xs sm:text-sm text-white/70">
            <span className="font-semibold text-white">
              4.9/5
            </span>{" "}
            based on 15+ client reviews
          </p>

          <div className="mt-2 flex items-center gap-2 text-xs text-white/50">
            <span className="w-2 h-2 rounded-full bg-green-400 shrink-0"></span>

            <span>Reviews from Google</span>
          </div>
        </div>
      </div>

      {/* Reviews */}
      <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6 px-0">
        {reviews.map((review) => (
          <blockquote
            key={review.name}
            className="
              glass
              w-full
              min-w-0
              rounded-[22px]
              sm:rounded-[24px]
              p-4
              sm:p-6
              hover:-translate-y-1
              transition
              duration-300
            "
          >
            {/* Top */}
            <div className="flex flex-col gap-4">
              {/* Client */}
              <div className="flex items-center justify-between gap-3 min-w-0">
                <div className="flex items-center gap-3 min-w-0">
                  <img
                    src={review.avatar}
                    alt={`${review.name} client`}
                    className="
                      w-11 h-11
                      sm:w-12 sm:h-12
                      rounded-full
                      object-cover
                      shrink-0
                    "
                    loading="lazy"
                  />

                  <div className="min-w-0">
                    <div className="font-semibold text-sm sm:text-base truncate">
                      {review.name}
                    </div>

                    <div className="flex gap-0.5 mt-1 text-xs sm:text-sm text-sunrise-300">
                      ★ ★ ★ ★ ★
                    </div>
                  </div>
                </div>

                {/* Google Icon */}
                <div
                  className="
                    w-9 h-9
                    sm:w-10 sm:h-10
                    rounded-xl
                    bg-white
                    flex
                    items-center
                    justify-center
                    shadow-sm
                    shrink-0
                  "
                >
                  <img
                    src={review.icon}
                    alt="Google"
                    className="w-6 h-6 sm:w-7 sm:h-7 object-contain"
                  />
                </div>
              </div>

              {/* Google Label */}
              <div className="flex items-center justify-between">
                <p className="text-xs text-white/50">
                  Google Review
                </p>

                <span className="text-xs text-green-400">
                  ✓ Verified
                </span>
              </div>
            </div>

            {/* Review */}
            <p
              className="
                mt-4
                sm:mt-5
                text-sm
                sm:text-base
                text-white/80
                leading-relaxed
                break-words
              "
            >
              “{review.quote}”
            </p>

            {/* Bottom */}
            <div className="mt-5 pt-4 border-t border-white/10">
              <div className="flex items-center gap-2 text-xs text-white/50">
                <span className="text-green-400">
                  ✓
                </span>

                <span>Client review</span>
              </div>
            </div>
          </blockquote>
        ))}
      </div>

      {/* Google CTA */}
      <div className="mt-8 sm:mt-10 text-center px-4">
        <a
          href="https://g.page/r/CbNyf4llvDPJEAI/review"
          target="_blank"
          rel="noopener noreferrer"
          className="
            btn-primary
            inline-flex
            items-center
            justify-center
            gap-2
            w-full
            sm:w-auto
            px-6
            py-3
          "
        >
          <span>★</span>
          <span>Read all Google Reviews</span>
        </a>

        <p className="mt-3 text-xs text-white/50">
          See what our clients are saying on Google
        </p>
      </div>
    </section>
  );
}

